module.exports = __webpack_public_path__ + "img/aspercreme_with_lidocaine_pain_relieving_creme.56ab4f27.png";